export default __webpack_public_path__ + "static/media/Legguards of the Living Tarim.4bd49d8e.jpg";